import { ApiService } from "../../../../../../api/services/api-service";

export class CitrixShareFileService {
  protected readonly api: ApiService;

  constructor(token: string, apiUrl: string, urlPrefix?: string) {
    this.api = new ApiService(apiUrl, urlPrefix, token ? { Authorization: `Bearer ${token}`} : {});
  }
}
